import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import { fetchPranthList } from './pranthService'; // Adjust path as needed



const ListSthan = () => {

  const handleRedirect = () => {
    navigate("/createfranchise");
  }
  const [Sthans, setSthans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const SthansPerPage = 15;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [pranthList, setPranthList] = useState([]);
  const [vibhagList, setVibhagList] = useState([]);
  const [selectedPranthId, setSelectedPranthId] = useState("");
  const [selectedVibhagId, setSelectedVibhagId] = useState("");

  const [jillaList, setJillaList] = useState([]);
  const [selectedJillaId, setSelectedJillaId] = useState("");

  const [khandList, setKhandList] = useState([]);
  const [selectedKhandId, setSelectedKhandId] = useState("");

  const [mandalamList, setMandalamList] = useState([]);
  const [selectedMandalamId, setSelectedMandalamId] = useState("");



  // const fetchPranthList = async () => {
  //   try {
  //     // const res = await axiosPrivate.get("list-pranths");
  //     // setPranthList(res.data);
  //     setPranthList([
  //       { id: "1", name: "ഉത്തര കേരളം" },
  //       { id: "2", name: "ദക്ഷിണ കേരളം" },
  //     ]);
  //   } catch (err) {
  //     console.error("Failed to fetch pranths", err);
  //     // setPranthList([
  //     //   { id: "1", name: "ഉത്തര കേരളം" },
  //     //   { id: "2", name: "ദക്ഷിണ കേരളം" },
  //     // ]);
  //   }
  // };

  const handleViewClick = (SthanId, SthanName) => {
    // Navigate to the GetFranchise component with franchiseId as a URL parameter
    navigate(`/sthan/users/${SthanId}/${SthanName}`);
  };

  const handleViewGurudakshina = (SthanId, SthanName) => {
    navigate(`/admin/list/GurudakshinaInSthan/${SthanId}/${SthanName}`);
  };

  const handleEditClick = (franchiseId) => {
    navigate(`/UpdateFranchise/${franchiseId}`);
  };

  useEffect(() => {
    const getPranths = async () => {
      const data = await fetchPranthList(); // Get data from the service
      setPranthList(data);                  // Set data to state
    };

    getPranths();
  }, []);


  const fetchVibhagList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-vibhags?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setVibhagList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch vibhags", err);
      setVibhagList([]);
      return [];
    }
  };


  const fetchJillaList = useCallback(async () => {
    try {
      const res = await axiosPrivate.get(`list-jillas?vibhag_id=${selectedVibhagId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setJillaList(data);
      if (data.length > 0) {
        setSelectedJillaId(data[0].jilla_id); // default selection
      } else {
        setSelectedJillaId("");
      }
    } catch (err) {
      console.error("Jilla fetch failed:", err);
      setError("Failed to load jilla list");
      setJillaList([]);
      setSelectedJillaId("");
    }
  }, [axiosPrivate, selectedVibhagId]);





  const fetchKhands = useCallback(async () => {
    if (!selectedJillaId) return;

    setLoading(true);
    setSthans([]);
    try {
      const res = await axiosPrivate.get(`list-khands?jilla_id=${selectedJillaId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setKhandList(data);
      if (data.length > 0) {
        setSelectedKhandId(data[0].khand_id); // optional default
      } else {
        setSelectedKhandId("");
      }
    } catch (err) {
      console.error("Khand fetch failed:", err);
      setError("Failed to load Khand list");
      setKhandList([]);
      setSelectedKhandId("");
    } finally {
      setLoading(false);
    }
  }, [axiosPrivate, selectedJillaId]);



  useEffect(() => {
    fetchPranthList();
  }, []);

  useEffect(() => {
    if (selectedPranthId) {
      fetchVibhagList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {
          setSelectedVibhagId(vibhags[0].vibhag_id);
        } else {
          setSelectedVibhagId("");
          setVibhagList([]);
          setSelectedJillaId("");
          setJillaList([]);
          setSthans([]);
          setKhandList([]);              // ✅ Add this line
          setSelectedKhandId("");        // ✅ Add this line
          setMandalamList([]);              // ✅ Add this line
          setSelectedMandalamId("");        // ✅ Add this line
          setError("No vibhags for selected pranth");
        }
      });
    }
  }, [selectedPranthId]);



  useEffect(() => {
    if (selectedVibhagId) {
      fetchJillaList();
    }
  }, [selectedVibhagId]);

  // useEffect(() => {
  //   if (selectedJillaId) {
  //     setCurrentPage(1); // Reset to page 1 when Jilla changes
  //     setError(null);
  //     setLoading(true);
  //     fetchKhands();
  //   }
  // }, [selectedJillaId]);
  useEffect(() => {
    if (selectedJillaId) {
      fetchKhands();
    }
  }, [selectedJillaId]);


  useEffect(() => {
    const fetchTableData = async () => {
      if (!selectedMandalamId) return;


      setLoading(true);
      setSthans([]);      // ⬅️ Clear old data here
      setError(null);         // Clear any old errors

      try {
        const res = await axiosPrivate.get(`list-sthans?mandal_id=${selectedMandalamId}`);
        setSthans(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Mandalam fetch failed:", err);
        setError("Failed to load Mandalam list");
        setSthans([]);
      } finally {
        setLoading(false);
      }
    };


    fetchTableData();
  }, [selectedMandalamId]);



  useEffect(() => {
    const fetchMandalamList = async () => {
      if (!selectedKhandId) {
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]); // clear table
        return;
      }

      setLoading(true);
      try {
        const res = await axiosPrivate.get(`list-mandals?khand_id=${selectedKhandId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setMandalamList(data);
        if (data.length > 0) {
          const firstMandalamId = data[0].mandal_id;
          setSelectedMandalamId("");  // force change
          setTimeout(() => {
            setSelectedMandalamId(firstMandalamId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedMandalamId("");
          setSthans([]); // clear table
        }

      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load Sthan list");
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMandalamList();
  }, [selectedKhandId]);






  const indexOfLastFranchise = currentPage * SthansPerPage;
  const indexOfFirstFranchise = indexOfLastFranchise - SthansPerPage;
  const currentFranchise = Sthans.slice(indexOfFirstFranchise, indexOfLastFranchise);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(Sthans.length / SthansPerPage);

  // if (loading) {
  //   return <div className="loading">Loading...</div>;
  // }

  // if (error) {
  //   return <div className="error">{error}</div>;
  // }

  return (
    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Sthan</button> */}
          <h3>Sthan List</h3>
          <Row className="mb-3">
            <Col md={1}></Col>
            <Col md={2}>
              <Form.Label className="newformstyle">Select Pranth</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedPranthId}
                onChange={(e) => {
                  const pranthId = e.target.value;
                  setSelectedPranthId(pranthId);

                  if (!pranthId) {
                    // Clear vibhag, jilla, and table if no Pranth selected
                    setVibhagList([]);
                    setSelectedVibhagId("");
                    setJillaList([]);
                    setSelectedJillaId("");
                    setSthans([]);

                    setKhandList([]);
                    setSelectedKhandId("");
                    setSthans([]);
                  }
                }}
              >
                <option value="">-- Select Pranth --</option>
                {pranthList.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select>

            </Col>

            <Col md={2}>
              <Form.Label className="newformstyle">Select Vibhag</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedVibhagId}
                onChange={(e) => {
                  const vibhagId = e.target.value;
                  setSelectedVibhagId(vibhagId);

                  if (!vibhagId) {
                    // Clear Jilla list and selection if no Vibhag selected
                    setJillaList([]);
                    setSelectedJillaId("");
                    setSthans([]); // Optional: clear table too

                    setKhandList([]);
                    setSelectedKhandId("");
                    setSthans([]);
                  }
                }}
                disabled={!vibhagList.length}
              >
                <option value="">-- Select Vibhag --</option>
                {Array.isArray(vibhagList) &&
                  vibhagList.map((v) => (
                    <option key={v.vibhag_id} value={v.vibhag_id}>
                      {v.vibhag_name}
                    </option>
                  ))}
              </Form.Select>

            </Col>
            <Col md={2}>
              <Form.Label className="newformstyle">Select Jilla</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedJillaId}
                onChange={(e) => {
                  const jillaId = e.target.value;
                  setSelectedJillaId(jillaId);

                  if (!jillaId) {
                    setKhandList([]);
                    setSelectedKhandId("");
                    setSthans([]);
                  }
                }}
                disabled={!jillaList.length}
              >
                <option value="">-- Select Jilla --</option>
                {jillaList.map((j) => (
                  <option key={j.jilla_id} value={j.jilla_id}>
                    {j.jilla_name}
                  </option>
                ))}
              </Form.Select>

            </Col>
            <Col md={2}>
              <Form.Label className="newformstyle">Select Khand</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedKhandId}
                onChange={(e) => setSelectedKhandId(e.target.value)}
                disabled={!khandList.length}
              >
                <option value="">-- Select Khand --</option>
                {khandList.map((k) => (
                  <option key={k.khand_id} value={k.khand_id}>
                    {k.khand_name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={2}>
              <Form.Label className="newformstyle">Select Mandalam</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedMandalamId}
                onChange={(e) => {
                  const mandalamId = e.target.value;
                  setSelectedMandalamId(mandalamId); // Correctly set Mandalam ID
                  // Remove this:
                  // setSelectedKhandId(khandId);
                  // setMandalamList([]);
                  // setSthans([]);
                }}
                disabled={!mandalamList.length}
              >

                <option value="">-- Select Mandalam --</option>
                {mandalamList.map((m) => (
                  <option key={m.mandal_id} value={m.mandal_id}>
                    {m.mandal_name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={1}></Col>


          </Row>

          <table id="customers">
            <thead>
              <tr>
                <th>Sthan ID</th>
                <th>Sthan Name</th>
                <th>Sthan Name (MALAYALAM)</th>
                <th>Mandal Name</th>
                <th>Options</th>
              </tr>
            </thead>
            <tbody>
              {error ? ( // If there's an error
                <tr>
                  <td colSpan="6" className="text-danger text-center">
                    {error} {/* Show the error inside the table */}
                  </td>
                </tr>
              ) : Sthans.length === 0 ? ( // If no data
                <tr>
                  <td colSpan="6">No jillas available.</td>
                </tr>
              ) : ( // If there is data
                currentFranchise.map(Sthan => (
                  <tr key={Sthan.sthan_id}>
                    <td>{Sthan.sthan_id}</td>
                    <td>{Sthan.search_tag}</td>
                    <td>{Sthan.sthan_name}</td>
                    <td>{Sthan.mandal_name}</td>
                    <td>
                      <div className="d-flex justify-content-center">
                        <button type="button" className="btn btn-info btn-ico newicobtn newviewbtn" onClick={() => handleViewClick(Sthan.sthan_id, Sthan.search_tag)}>
                          All users
                        </button>
                        <button type="button" className="btn btn-info btn-ico newicobtn newviewbtn" onClick={() => handleViewGurudakshina(Sthan.sthan_id, Sthan.search_tag)}>
                          Gurudakshina
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>

          </table>

          {totalPages > 1 && (
            <div className="pagination">
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  disabled={currentPage === index + 1}
                >
                  {index + 1}
                </button>
              ))}
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
            </div>
          )}
        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default ListSthan;
